import * as React from "react";
import { forwardRef } from "react";
const SvgVerticalMenu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 24 24", fill: "none", stroke: "#000000", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-ellipsis-vertical-icon lucide-ellipsis-vertical", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 1 }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 5, r: 1 }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 19, r: 1 }));
const ForwardRef = forwardRef(SvgVerticalMenu);
export default ForwardRef;
